import React from "react";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";

import styles from "./ItemCard.module.scss";
import { SaleItemInterface } from "../../types/interfaces";
import {
  getClusterImageUrl,
  getFirstImage,
} from "../../utils/functions/getImageUri";
import { itemRoute, clusterRoute } from "../../utils/constants";
import { selectClusterList } from "../../../store/slices/clusterListSlice";
import { useItemPrice } from "../../hooks/useItemPrice";
import { FavoriteButton } from "../favoriteButton/FavoriteButton";

interface Props {
  item: SaleItemInterface;
  lastItemRef?: (node: HTMLDivElement | null) => void;
}

export const ItemCard: React.FC<Props> = ({ item, lastItemRef }) => {
  const clusters = useSelector(selectClusterList);
  const cluster = clusters.find((c) => c.id === item.clusterId);

  const { displayPrice, isComputed } = useItemPrice(item);

  const image = getFirstImage(item.files);
  const isCartEnabled = process.env.REACT_APP_CART_ENABLED === "true";
  const isFavorite = !!item.selected?.some((s) => s.isActive);
  const isOutOfStock =
    item.isAvailableInSelectedCity !== false &&
    item.isInStockInSelectedCity === false;

  return (
    <div className={styles.Card} ref={lastItemRef}>
      <Link to={itemRoute(item.id)} className={styles.ImageLink}>
        <div className={styles.ImageWrap}>
          {image && cluster ? (
            <img
              src={getClusterImageUrl(cluster, image)}
              alt={item.name}
              className={styles.Image}
              loading="lazy"
            />
          ) : (
            <div className={styles.ImagePlaceholder} />
          )}

          {isOutOfStock && (
            <span className={styles.OutOfStockBadge}>Нет в наличии</span>
          )}

          <div
            className={styles.FavoriteWrap}
            onClick={(e) => e.preventDefault()}
          >
            <FavoriteButton itemId={item.id} isFavorite={isFavorite} />
          </div>
        </div>
      </Link>

      <div className={styles.Info}>
        {cluster && (
          <Link
            to={clusterRoute(cluster.id)}
            className={styles.ClusterLink}
            onClick={(e) => e.stopPropagation()}
          >
            <img
              src={`https://${cluster.domain}/icons/logo512.png`}
              alt={cluster.name}
              className={styles.ClusterLogo}
            />
            <span className={styles.ClusterName}>{cluster.name}</span>
          </Link>
        )}

        <Link to={itemRoute(item.id)} className={styles.NameLink}>
          <h3 className={styles.Name}>{item.name}</h3>
        </Link>

        {cluster?.cdek?.enabled && (
          <span className={styles.CdekBadge}>• Доставка по РФ</span>
        )}

        <div className={styles.BottomRow}>
          {displayPrice > 0 && (
            <span className={styles.Price}>
              {displayPrice} ₽
              {isComputed && (
                <span className={styles.KitHint}> (комплект)</span>
              )}
            </span>
          )}

          {isCartEnabled && (
            <button
              className={styles.CartBtn}
              disabled={isOutOfStock}
              onClick={(e) => {
                e.preventDefault();
                if (isOutOfStock) return;
                alert("Корзина скоро!");
              }}
            >
              В корзину
            </button>
          )}
        </div>
      </div>
    </div>
  );
};